<div class="ribbon {{ribbonClass}}">
  <span class="ribbon__content">
  <ng-content></ng-content>
  </span>
</div>

